namespace Portico.Models.Legacy {
    
    export class ResponseModelPatientLookupResultModel {
        success: boolean;
        messages: Array<string>;
        data: PatientLookupResultModel;

        constructor(obj?: Portico.Services.Legacy.EnrollmentService.Models.ResponseModelPatientLookupResultModel){
            this.success = null;
            this.messages = null;
            this.data = null;

            if(obj){
                this.success = obj.success || null;
                this.messages = (obj.messages || []).concat();
                this.data = new PatientLookupResultModel(obj.data || null);
            }
        }

        public toModel(): Portico.Services.Legacy.EnrollmentService.Models.ResponseModelPatientLookupResultModel {
            return {
                success: this.success,
                messages: (this.messages || []).concat(),
                data: this.data.toModel(),
            };
        }
    }   
}